import React from 'react'
import { matchPath, withRouter, Link } from 'react-router-dom'
import { connect } from 'react-redux'

const Breadcrumb = ({ routes = [], history, session }) => {

    const getPaths = (pathname) => {
      const paths = ['/'];

      if (pathname === '/') {
        return paths;
      }

      pathname
        .split('/')
        .reduce((previousPath, currentSegment) => {
          const newPath = `${previousPath}/${currentSegment}`;

          if (!currentSegment.includes('=')) {
            paths.push(newPath);
          }

          return newPath;
        });

      return paths;
    };

	const findRouteName = (url, routesList) => {
		const route = routesList.find(({ path, exact }) =>
			matchPath(url, { path, exact })
		) || {};

		return {
			name: route.name,
			path: route.path,
			url: route.url
		};
	};

	const breadcrumbs = (routeConfiguration) => {
        const currentPath = history.location.pathname;
        const paths = getPaths(currentPath);

        return paths.map((path) => findRouteName(path, routeConfiguration));
    };

    return (
        <ol className="breadcrumb">
            {
                (() => {

                    const items = breadcrumbs(routes)

                    const lastIndex = items.length - 1

                    const adminType = session && session.admin_type;

                    const breads = items
                    .filter($0 => $0.path)
                    .map((route, key) => {

                        if (route.path) {

                            const disabled = adminType ? adminType.id === 12 : key === lastIndex

                            if (disabled) {
                                return <span>{route.name}</span>
                            }

                            return <Link to={route.path}>{ route.name }</Link>
                        }

                        return null
                    })
                    .filter($0 => $0)
                    .reduce((acc, child, index) => {
                        const notLast = index < lastIndex

                        if (notLast) {
                            acc.push(child, <span className="mx-2">/</span>)
                        } else {
                            acc.push(child)
                        }
                        return acc
                    }, [])
                    .map((item, key) => {
                        return {...item, key}
                    })

                    return breads
                })()

            }
        </ol>
    )
}

export default connect(({ branch }) => ({
    branch
}))(withRouter(Breadcrumb))



// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js